var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "2900",
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.PleaseEnterTheWarehouseNumber"
                )
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "look",
                        disabled: !_vm.selectedData,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "new", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Edit",
                        disabled: !_vm.selectedData,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.editHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Delete",
                        disabled: !_vm.selectedData,
                        type: "danger"
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "print",
                        disabled: !_vm.selectedData,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onPrintHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Statistics", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.statisticsPage()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ExportAllToExcel", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportAllToExcel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExportAllToExcel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "dimensionsEntry", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.dimensionsEntryHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DimensionsEntry")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "weightHandling", type: "primary" },
                      on: { click: _vm.weightHandlingHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WeightHandling")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": _vm.isRe ? "9300100" : "9300000",
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: _vm.onGridReady
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": _vm.isRe ? "9300101" : "9300001",
                  total: _vm.total,
                  page: _vm.filterJson.pageNum,
                  limit: _vm.filterJson.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filterJson, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filterJson, "pageSize", $event)
                  },
                  pagination: _vm.toQueryByPage
                }
              })
            ],
            1
          ),
          _vm.statistics.show
            ? _c("warehouse-statistics-window", {
                attrs: {
                  visible: _vm.statistics.show,
                  "warehouses-list": _vm.statistics.warehousesList
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.statistics, "show", $event)
                  }
                }
              })
            : _vm._e(),
          _c("picture-view-window", {
            attrs: {
              visible: _vm.pictureView.visible,
              job: _vm.pictureView.j,
              model: _vm.pictureView.model,
              title: _vm.pictureView.title,
              "file-name": _vm.pictureView.fileName,
              type: _vm.pictureView.type
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pictureView, "visible", $event)
              }
            }
          }),
          _vm.weightHandlingWindow.visible
            ? _c("weight-handling", {
                attrs: { visible: _vm.weightHandlingWindow.visible },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.weightHandlingWindow, "visible", $event)
                  },
                  close: function($event) {
                    _vm.weightHandlingWindow.visible = false
                  }
                }
              })
            : _vm._e(),
          _vm.dimensionsDialog.visible
            ? _c("dimensions-window", {
                attrs: {
                  visible: _vm.dimensionsDialog.visible,
                  uuid: _vm.dimensionsDialog.uuid,
                  "open-imperial": _vm.openImperial
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.dimensionsDialog, "visible", $event)
                  },
                  close: function($event) {
                    _vm.dimensionsDialog.visible = false
                  },
                  queryHandler: _vm.toQueryByPage
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }